export * from './PaymentSmallIcon'
